export interface BlockingDocument {
  id: string;
  name: string;
}

export const COPY_BLOCKED_ERROR_CODE =
  "DOCUMENT_SPACE_COPY_BLOCKED_BY_NON_SHAREABLE_DOCUMENTS";

export function blockingDocumentsFromCloneError(
  error: unknown,
): BlockingDocument[] | undefined {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  const graphQLErrors = (error as { graphQLErrors?: unknown }).graphQLErrors;
  if (!Array.isArray(graphQLErrors)) {
    return undefined;
  }

  for (const graphQLError of graphQLErrors) {
    if (!graphQLError || typeof graphQLError !== "object") {
      continue;
    }

    const extensions = (graphQLError as { extensions?: unknown }).extensions;
    if (!extensions || typeof extensions !== "object") {
      continue;
    }

    const { code, blockingDocuments: documents } = extensions as {
      code?: unknown;
      blockingDocuments?: unknown;
    };

    if (
      code !== COPY_BLOCKED_ERROR_CODE ||
      !Array.isArray(documents) ||
      documents.length === 0 ||
      !documents.every(
        (document) =>
          document &&
          typeof document === "object" &&
          typeof (document as { id?: unknown }).id === "string" &&
          /^\d+$/.test((document as { id: string }).id) &&
          typeof (document as { name?: unknown }).name === "string" &&
          (document as { name: string }).name.trim().length > 0,
      )
    ) {
      continue;
    }

    return documents.map((document) => ({
      id: (document as { id: string }).id,
      name: (document as { name: string }).name,
    }));
  }

  return undefined;
}
